import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MapMarker } from '@angular/google-maps';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShopService } from '../shop.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit {
  // Help: https://risanb.com/posts/colorful-google-maps-marker/
  MAP_MARKER = 'M 12,2 C 8.13,2 5,5.13 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.87 -3.13,-7 -7,-7 z';
  center: google.maps.LatLngLiteral = { lat: 48.8932, lng: 2.2879 };
  zoom = 15.5;
  options: google.maps.MapOptions = {
    zoomControl: true,
    scrollwheel: true,
    disableDoubleClickZoom: false,
    zoomControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM },
    streetViewControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM },
    fullscreenControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM },
    clickableIcons: false,
    styles: [{
      featureType: "poi",
      elementType: "labels",
      stylers: [
        { visibility: "off" }
      ]
    }]
  };
  previousClickedShop: any = null;
  previousClickedMarker: MapMarker = null;
  shops$: Observable<any>;
  businessSectorFilter: string = null;

  @Output() markerClick = new EventEmitter<any>();

  constructor(private route: ActivatedRoute, private router: Router, private shopService: ShopService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['filterBy'] !== this.businessSectorFilter) {
        this.businessSectorFilter = params['filterBy'];

        if (!this.shops$) {
          this.shops$ = this.shopService.getOverviews().pipe(map(overviews => {
            const businessSectors = overviews.businessSectors;
            const shops = overviews.shops?.map(shop => {
              let businessSector = businessSectors[shop.businessSector];
              shop.marker = {
                label: {
                  fontFamily: 'Material Design Icons',
                  fontSize: "16px",
                  // Codes: https://cdn.materialdesignicons.com/5.1.45/
                  // fontWeight: '300',
                  text: (businessSector?.iconSymbol) ? String.fromCodePoint(parseInt(businessSector?.iconSymbol, 16)) : '\u{F04DC}',
                  color: '#FFFFFF'
                },
                options: {
                  icon: {
                    // url: 'favicon.png',
                    // size: new google.maps.Size(20, 20)
                    path: this.MAP_MARKER,
                    fillColor: (businessSector?.color) ? `#${businessSector.color}` : '#2E3D99',
                    scale: 2,
                    labelOrigin: new google.maps.Point(12, 10),
                    fillOpacity: 1,
                    strokeColor: '#FFFFFF',
                    anchor: new google.maps.Point(12, 22),
                  }
                },
              };
              return shop;
            });
            return shops;
          }));
        }
      }
    });
  }

  markerClickInternal(event: MouseEvent, shop: any, marker: MapMarker) {
    this.resetMarkerSelection();

    marker._marker.setZIndex(1000);
    // marker._marker.setAnimation(google.maps.Animation.BOUNCE);

    const newOptions = { icon: { ...shop.marker.options.icon } };
    const newLabel = { ...shop.marker.label };
    newOptions.icon.scale = 2.5;
    newLabel.fontSize = "20px";

    marker._marker.setOptions(newOptions);
    marker._marker.setLabel(newLabel);

    this.previousClickedMarker = marker;
    this.previousClickedShop = shop;
    //this.markerClick.emit(shop);
    this.router.navigate([], { relativeTo: this.route, queryParams: { filterBy: this.businessSectorFilter, shop: shop.id } });
  }

  resetMarkerSelection() {
    if (this.previousClickedMarker) {
      this.previousClickedMarker._marker.setZIndex(1);
      this.previousClickedMarker._marker.setOptions(this.previousClickedShop.marker.options);
      this.previousClickedMarker._marker.setLabel(this.previousClickedShop.marker.label);
    }
  }

  markerLabelColor(markerColor: string) {
    const colorInt = Number.parseInt(markerColor, 16);
    // tslint:disable-next-line: no-bitwise
    const red = (colorInt >> 16) & 0xFF;
    // tslint:disable-next-line: no-bitwise
    const green = (colorInt >> 8) & 0xFF;
    // tslint:disable-next-line: no-bitwise
    const blue = (colorInt >> 0) & 0xFF;
    return Math.sqrt(
      red * red * .241 +
      green * green * .691 +
      blue * blue * .068) < 130 ? 'ffffff' : '000000';
  }
}
